import { CSSObject } from "@emotion/react";
import { mediaQueryStyles, constants } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

const { Breakpoints } = constants.breakpoints;

const {
  colors: { ui },
} = constants;
const white700 = ui.white[700];

export const promotedContentContainerCss: CSSObject = {
  backgroundColor: ui.core[25],
  position: "relative",
};

export const innerPageContainerCss = (isLoading: boolean | undefined) => ({
  height: isLoading ? "90vh" : "unset",
});

export const errorToastCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "14px",

  [breakpoint.downTo(Breakpoints.sm)]: {
    flexDirection: "row",
  },

  p: {
    margin: 0,
  },
};

const commonLinkCss: CSSObject = {
  fontFamily: "Circular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "100%",
  color: white700,
};

export const pageLinkCss: CSSObject = {
  marginRight: "16px",
  ...commonLinkCss,
};
